import { DestroyRef, Directive, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgControl } from '@angular/forms';
import { sanitizeContactSearchInput } from '@shared/utils/contact-search.utils';
import { isNil } from 'lodash';

/**
 * Cleans a contact search box while the user types or pastes, so what is on screen is exactly what
 * gets searched and junk carried along with a phone or an email cannot defeat the duplicate lookup.
 *
 * Only the character-removal pass runs here - the dot repair done by `sanitizeContactSearchTerm`
 * would make a dot impossible to type into an email, so the search itself must still sanitize the
 * term on submit.
 */
@Directive({ selector: '[sanitizeContactSearch]' })
class SanitizeContactSearchDirective implements OnInit {
    private readonly ngControl = inject(NgControl);

    private readonly destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        const control = this.ngControl.control;

        control?.valueChanges
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((value: string) => {
                const sanitized = sanitizeContactSearchInput(value);

                if (!isNil(value) && sanitized !== value) {
                    control.setValue(sanitized, { emitEvent: false });
                }
            });
    }
}

export { SanitizeContactSearchDirective };
